import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Select, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const DynamicInput = ({
  translate,
  countryList,
  setSelectedCountry,
  selectedCountry,
}: any) => {
  const [inputType, setInputType] = useState('text');
  const [value, setValue] = useState('');
  const [cursorPosition, setCursorPosition] = useState(0);
  const [hasStartedTyping, setHasStartedTyping] = useState(false);

  const inputRef = useRef(null);
  const phoneInputRef = useRef(null);

  useEffect(() => {
    const currentRef: any =
      inputType === 'number' ? phoneInputRef.current : inputRef.current;
    if (currentRef?.input) {
      currentRef.input.setSelectionRange(cursorPosition, cursorPosition);
      currentRef.focus();
    }
  }, [inputType, cursorPosition]);

  const handleInputChange = (e: any) => {
    const inputValue = e.target.value;
    setCursorPosition(e.target.selectionStart || 0);
    setValue(inputValue);

    if (!inputValue.trim()) {
      setHasStartedTyping(false);
      setInputType('text');
      setSelectedCountry(null);
      return;
    }

    if (!hasStartedTyping) {
      const firstChar = inputValue[0];
      const isNumeric = /^\d$/.test(firstChar);
      setInputType(isNumeric ? 'number' : 'text');
      setHasStartedTyping(true);
    }
  };

  const commonInputProps = {
    value,
    onChange: handleInputChange,
    onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
      const position = e.target.selectionStart || 0;
      setCursorPosition(position);
    },
    onKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => {
      const position = (e.target as HTMLInputElement).selectionStart || 0;
      setCursorPosition(position);
    },
    onClick: (e: React.MouseEvent<HTMLInputElement>) => {
      const position = (e.target as HTMLInputElement).selectionStart || 0;
      setCursorPosition(position);
    },
  };

  const phoneInput = (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        size="large"
        options={countryList}
        placeholder={translate('Country')}
        style={{ width: '30%' }}
        onChange={(value) => {
          const phoneCode = countryList?.find(
            (item: any) => item.value === value
          )?.phoneCode;
          setSelectedCountry(phoneCode);
        }}
      />
      <Input
        {...commonInputProps}
        ref={phoneInputRef}
        type="text"
        placeholder={translate('email / Phone number')}
        prefix={<span>{selectedCountry}</span>}
        onChange={handleInputChange}
        className="phone-input"
        disabled={!selectedCountry}
        value={value}
      />
    </Space.Compact>
  );

  const emailInput = (
    <Input
      {...commonInputProps}
      ref={inputRef}
      size="large"
      type="text"
      placeholder={translate('email / Phone number')}
      prefix={<UserOutlined />}
      onChange={handleInputChange}
      className="phone-input"
      value={value}
    />
  );

  return (
    <Form.Item
      name="username"
      label={translate('Email / Phone number')}
      rules={[
        {
          required: true,
          message: translate('Please input your email or phone number'),
        },
      ]}
    >
      {inputType === 'number' ? phoneInput : emailInput}
    </Form.Item>
  );
};

export default DynamicInput;
